import * as React from "react";
import {
  List,
  Datagrid,
  TextField,
  EditButton
} from "react-admin";

export default function Shoots(props) {
  return (
    <List {...props} title="Shoots">
      <Datagrid rowClick="edit">
        <TextField source="id" />
        {/*<ReferenceField source="userId" reference="users">*/}
        {/*  <TextField source="name" />*/}
        {/*</ReferenceField>*/}
        <TextField source="title" />
        <TextField source="description" />
        <EditButton />
      </Datagrid>
    </List>
  );
}
